module.exports = {
  paper: {
    background: 'palette.overlaySurface',
    color: 'palette.overlayContrast',
    border: { radius: 'radius.md' },
    padding: 'spacing.xs',
    maxWidth: {
      sm: '100px',
      md: '200px',
      lg: '300px',
      xl: '500px',
    },
    transition: {
      duration: '200ms',
    },
  },
};
